enum ClientRowErrorType{
  FILE = 'FILE',
  DATABASE = 'DATABASE'
}

export default ClientRowErrorType;